import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AssignmentOptimizerKpiDto } from '@wilson/interfaces';
import { LocalizationState } from '@wilson/localization';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimelineDraftModeKpiTranslationHelperService {
  private store = inject(Store);

  transformDataToTranslatedData(data: AssignmentOptimizerKpiDto[]): Observable<
    (AssignmentOptimizerKpiDto & {
      translatedName: string;
      translatedDescription: string;
    })[]
  > {
    return this.store.select(LocalizationState.getEntityLang).pipe(
      map((nameDescriptor) => {
        const nameDescriptorInSnakeCase = nameDescriptor.replace(
          /[A-Z]/g,
          (letter) => `_${letter.toLowerCase()}`,
        ) as keyof AssignmentOptimizerKpiDto;
        const descriptionDescriptorInSnakeCase =
          nameDescriptorInSnakeCase.replace(
            'name',
            'description',
          ) as keyof AssignmentOptimizerKpiDto;

        return data.map((rawData) => ({
          ...rawData,
          translatedName:
            rawData[nameDescriptorInSnakeCase] || rawData.name_en || '',
          translatedDescription:
            rawData[descriptionDescriptorInSnakeCase] ||
            rawData.description_en ||
            '',
        }));
      }),
    );
  }
}
